// Contact.js
import React from 'react';

function Contact() {
  return (
    <div>
      <h2>Contact Us</h2>
      <p>You can reach us by email at example@example.com</p>
      <p>Or by phone at 123-456-7890</p>
    </div>
  );
}

export default Contact;
